var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "twitter 1",
    clipPath: "url(#clip0_355_3023)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_355_3023",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clip0_84_15697"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M36 0H0V36H36V0Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_355_3023)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M31.7812 0H4.21875C1.8888 0 0 1.8888 0 4.21875V31.7812C0 34.1112 1.8888 36 4.21875 36H31.7812C34.1112 36 36 34.1112 36 31.7812V4.21875C36 1.8888 34.1112 0 31.7812 0Z",
    fill: "#2E4455"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M25.0248 7.03125H28.7463L20.616 16.3238L30.1807 28.9688H22.6916L16.8258 21.2996L10.1141 28.9688H6.39038L15.0866 19.0294L5.91113 7.03125H13.5903L18.8925 14.0411L25.0248 7.03125ZM23.7187 26.7413H25.7808L12.4698 9.14175H10.257L23.7187 26.7413Z",
    fill: "#F6F6F6"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_355_3023"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterSvg);
export default __webpack_public_path__ + "static/media/twitterSvg.cb47f3884c1ce3a9c6510299fc3d0272.svg";
export { ForwardRef as ReactComponent };